import { Button, Col, Modal, Row, Spinner } from "react-bootstrap";
import { useAuth } from "react-oidc-context";

export const LoginBox = () => {
    const auth = useAuth();

    return <Modal show={!auth.isAuthenticated}>
        <Modal.Header>
            <Modal.Title>Sign in</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {auth.isLoading ?
                <Spinner /> :
                <Col style={{}}>
                    <Row>

                        <Button onClick={() => auth.signinRedirect()}>Sign in</Button>
                    </Row>
                    <Row>

                        <Button disabled onClick={() => auth.signinRedirect({ prompt: 'create' })}>Sign up</Button>
                    </Row>
                </Col>}
        </Modal.Body>
        <Modal.Footer>
            {/* <button onClick={() => auth.signoutRedirect()}>Sign out</button> */}
        </Modal.Footer>
    </Modal>;


}